// store.js
import { configureStore } from "@reduxjs/toolkit";
import statementReducer from "./slices/statementSlice";

export const store = configureStore({
    reducer: {
        statement: statementReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            // ha új state kerül be, vagy változnak az adatok, akkor azért érdemes visszakapcsolni és kipróbálni hogy minden fasza-e,
            // Ezzel tiltod le a szerializálhatóság ellenőrzését
            serializableCheck: false,

            // Ha vannak specifikus akciók vagy state részek, amiket ki akarsz zárni
            // (ez ritkább, de lehetséges, ha tudod, hogy mi az, ami nem szerializálható, de szándékosan ott van)
            // serializableCheck: {
            //   ignoredActions: ['your/actionType'], // Akció típusok kizárása
            //   ignoredPaths: ['some.state.path'], // State path-ek kizárása
            //   // ... további beállítások
            // },
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
